// import logo from './logo.svg';
import './App.css';
import { Routes, Route } from "react-router-dom";
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Reports from './pages/Reports';
import ReportReasons from './pages/Reportreason';
import SettingSidebar from './components/Setttingsidebar';
import Hashtags from './pages/Hashtags';
import Hashtagdetails from './pages/Hashtagdetails';
import PostView from './pages/PostView';
import Posts from './pages/Posts';
import Gifts from './pages/Gifts';
import Users from './pages/Users';
import UserView from './pages/Userview';
import Lives from './pages/Lives';
import Withdrawal from './pages/Withdrawals';
import Adminwithdraw from './pages/Adminwithdraw';
import LiveSettings from './pages/Settings/Liveadmin';
import Limit from './pages/Settings/Limit';
import AppSettings from './pages/Settings/AppSettings';
import Giphy from './pages/Settings/Giphy';
import Userlevel from './pages/Settings/Userlevel';
import Privacy from './pages/Settings/Privacy';
import Terms from './pages/Settings/Terms';
import AdminSettings from './pages/Settings/AdminSettings';
import Admob from './pages/Settings/Admop';
import Notifications from './pages/Notifications';
import Coinpackages from './pages/CoinPackages';
import Restrictions from './pages/Restrictions';
import CurrencySettings from './pages/Settings/CurrencySettings';
import CurrencyGrid from './pages/Settings/CurrencyGrid';
import LoginSample from './pages/Loginsample';
import Editprofile from './pages/Editprofile';
import BadWordsPage from './pages/Settings/Badwordsettings';
import DeepArsettings from './pages/Settings/DeepArsettings';
import ForgotPassword from './pages/ForgetPassword';
import ResetPassword from './pages/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const RequireAuth = ({ children }) => {
    const token = localStorage.getItem("adminToken");
    if (token) return children;
    return (
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100vh",fontSize:24,fontWeight:700,color:"#a855f7"}}>
        404 Not Found
      </div>
    );
  };
  return (
     <Routes>
      {/* <Route path="/" element={<Login />} /> */}
      <Route path="/" element={<Login />} />
       <Route element={<ProtectedRoute />}>
      <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="/Reports" element={<RequireAuth><Reports /></RequireAuth>} />
      <Route path="/ReportReasons" element={<RequireAuth><ReportReasons /></RequireAuth>} />
      <Route path="/SettingSidebar" element={<RequireAuth><SettingSidebar /></RequireAuth>} />
      <Route path="/Hashtags" element={<RequireAuth><Hashtags /></RequireAuth>} />
      <Route path="/Hashtagdetails/:tag" element={<RequireAuth><Hashtagdetails/></RequireAuth>} />
      <Route path="/PostView/:id" element={<RequireAuth><PostView/></RequireAuth>} />
      <Route path="/Posts" element={<RequireAuth><Posts/></RequireAuth>} />
      <Route path="/Gifts" element={<RequireAuth><Gifts/></RequireAuth>} />
      <Route path="/Users" element={<RequireAuth><Users/></RequireAuth>} />
      <Route path="/Userview/:id" element={<RequireAuth><UserView/></RequireAuth>} />
      <Route path="/lives" element={<RequireAuth><Lives/></RequireAuth>}></Route>
      <Route path="/withdrawal" element={<RequireAuth><Withdrawal/></RequireAuth>}></Route>
      <Route path="/Adminwithdraw" element={<RequireAuth><Adminwithdraw/></RequireAuth>}></Route>
      <Route path="/livesettings" element={<RequireAuth><LiveSettings/></RequireAuth>}></Route>
      <Route path="/limits" element={<RequireAuth><Limit/></RequireAuth>}></Route>
      <Route path="/app-settings" element={<RequireAuth><AppSettings/></RequireAuth>}></Route>
      <Route path="/giphy" element={<RequireAuth><Giphy/></RequireAuth>}></Route>
      <Route path="/user-levels" element={<RequireAuth><Userlevel/></RequireAuth>}></Route>
      <Route path="/admin-settings" element={<RequireAuth><AdminSettings/></RequireAuth>}></Route>
      <Route path="/admob" element={<RequireAuth><Admob/></RequireAuth>}></Route>
      <Route path="/notifications" element={<RequireAuth><Notifications/></RequireAuth>}></Route>
      <Route path="/coinpackages" element={<RequireAuth><Coinpackages/></RequireAuth>}></Route>
      <Route path="/restrictions" element={<RequireAuth><Restrictions/></RequireAuth>}></Route>
      <Route path="/currencysettings" element={<RequireAuth><CurrencySettings/></RequireAuth>}></Route>
      <Route path="/currencygrid" element={<RequireAuth><CurrencyGrid/></RequireAuth>}></Route>
      <Route path="/editprofile/:id" element={<RequireAuth><Editprofile/></RequireAuth>}></Route>
      <Route path="/badwordsfilters" element={<RequireAuth><BadWordsPage/></RequireAuth>}></Route>
      <Route path="/deeparsettings" element={<RequireAuth><DeepArsettings/></RequireAuth>}></Route>
      <Route path="/reset-password/:token" element={<ResetPassword/>}></Route>
      </Route>
       <Route path="/forget-password" element={<ForgotPassword/>}></Route>
      <Route path="/privacy-policy" element={<RequireAuth><Privacy/></RequireAuth>}></Route>
      <Route path="/terms" element={<RequireAuth><Terms/></RequireAuth>}></Route>
    </Routes>
  );
}

export default App;
